export default __webpack_public_path__ + "static/life_at_04-75d0903dadec9dd045723aae4dba22cd.jpg";